import React from "react";
import { Star, Quote } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Ricardo M.",
    city: "Araçoiaba da Serra",
    text: "Me atenderam super rápido na rodovia, preço bem abaixo dos outros que liguei. Guincho chegou em menos de 30 minutos.",
  },
  {
    name: "Patricia S.",
    city: "Sorocaba",
    text: "Atendimento honesto e ainda resolveram a mecânica depois. Economizei um bom dinheiro e não tive dor de cabeça.",
  },
  {
    name: "Anderson L.",
    city: "Votorantim",
    text: "Guincho de confiança na região. Já usei duas vezes e sempre fui muito bem atendido. Recomendo de olhos fechados.",
  },
  {
    name: "Juliana P.",
    city: "Salto de Pirapora",
    text: "Fiquei sem bateria no estacionamento do mercado. Vieram rápido, foram educados e cobraram um valor justo.",
  },
  {
    name: "Marcos F.",
    city: "Iperó",
    text: "Minha moto quebrou na estrada de madrugada. Apareceram em 40 minutos. Levaram com cuidado e pelo menor preço.",
  },
  {
    name: "Camila R.",
    city: "Sorocaba",
    text: "Cobriram o orçamento que outro guincho me passou. Ainda fizeram a revisão depois. Vou voltar com certeza.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="depoimentos"
      data-testid="testimonials-section"
      className="bg-[#171717] py-16 md:py-24 relative"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-block bg-[#E50914] px-3 py-1 mb-4">
            <span className="font-anton text-sm uppercase tracking-widest text-white">Quem já usou aprovou</span>
          </div>
          <h2 className="font-anton text-4xl md:text-6xl uppercase text-white leading-[0.95] mb-4">
            O que dizem nossos
            <br />
            <span className="text-[#E50914]">Clientes</span>
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            <div className="flex gap-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-[#E50914] text-[#E50914]" />
              ))}
            </div>
            <span className="font-anton text-xl text-white ml-2">5.0 · 187+ avaliações</span>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {TESTIMONIALS.map((t, i) => (
            <div
              key={i}
              data-testid={`testimonial-card-${i}`}
              className="bg-black border-2 border-zinc-800 hover:border-[#E50914] p-6 md:p-8 hover-lift transition-all relative"
            >
              <Quote className="absolute top-4 right-4 w-10 h-10 text-[#E50914]/20" fill="currentColor" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-[#E50914] text-[#E50914]" />
                ))}
              </div>
              <p className="font-work text-zinc-200 text-sm md:text-base leading-relaxed mb-6">"{t.text}"</p>
              <div className="border-t border-zinc-800 pt-4">
                <div className="font-anton text-lg text-white uppercase">{t.name}</div>
                <div className="font-work text-xs text-zinc-500 uppercase tracking-widest">{t.city}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
